export default __webpack_public_path__ + "static/media/phone_outline_blue.d69119ed.svg";